import { debounce } from './_debounce';

/**
 * Set scrollbar width
 */
const setScrollbarWidth = () => {
	const scrollbarWidth = `${window.innerWidth - document.body.clientWidth}px`;

	document.documentElement.style.setProperty( '--scrollbar-width', scrollbarWidth );

	if ( !window.CSS || !CSS.supports || !CSS.supports( '(--foo: bar)' ) ) {
		let style = document.getElementById( 'scrollbar-style' );

		if ( !style ) {
			style = document.createElement( 'style' );
			style.setAttribute( 'id', 'scrollbar-style' );
			document.querySelector( 'head' ).appendChild( style );
		}

		style.innerText = `.alignfull { max-width: calc(100vw - ${scrollbarWidth}); margin: 2em calc(50% - 50vw + ${scrollbarWidth}/2); }`;
	}
};

/**
 * Init Blog Navigation
 */
const init = () => {
	window.addEventListener( 'resize', debounce( setScrollbarWidth ) );
	setScrollbarWidth();
};

// Exports
export default init;
